import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-intl-redux";
import App from "app";
import store from "app/store";
import Promise from "promise-polyfill";
import bowser from "bowser";
import "whatwg-fetch";

import "@blueprintjs/core/dist/blueprint.css";
import "./index.css";

import { addLocaleData } from "react-intl";

import locale_en from "react-intl/locale-data/en";
import locale_it from "react-intl/locale-data/it";
import locale_ur from "react-intl/locale-data/ur";
import locale_de from "react-intl/locale-data/de";
import locale_el from "react-intl/locale-data/el";
import locale_es from "react-intl/locale-data/es";

addLocaleData([
  ...locale_en,
  ...locale_it,
  ...locale_ur,
  ...locale_de,
  ...locale_el,
  ...locale_es
]);

if (!window.Promise) {
  window.Promise = Promise;
}

const Unsupported = props => {
  return (
    <div
      style={{
        margin: "2em auto",
        fontSize: "18px",
        maxWidth: "40em"
      }}
    >
      <h2>Unsupported Browser</h2>
      <p style={{ margin: "1.5em auto" }}>
        Please use a modern browser. {bowser.name} {bowser.version} is currently
        not supported by the smarticipate Web application. We recommend using{" "}
        <a href="https://www.google.com/chrome/browser/desktop/">
          Google Chrome
        </a>{" "}
        or <a href="http://www.mozilla.org/firefox/new/">Mozilla Firefox</a>.
      </p>
    </div>
  );
};

const checkBrowser = () => {
  const isUnsupported = bowser.isUnsupportedBrowser(
    {
      firefox: "34",
      safari: "6",
      chrome: "39",
      msie: "12",
      msedge: "12"
    },
    window.navigator.userAgent
  );
  if (!isUnsupported) {
    return (
      <Provider store={store}>
        <App />
      </Provider>
    );
  }
  return <Unsupported />;
};

ReactDOM.render(checkBrowser(), document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js